// extracted by mini-css-extract-plugin
export var printerCard = "_k6-1";
export var printerCardConfigured = "_k6-2";
export var printerCardError = "_k6-3";
export var printerCardsContainer = "_k6-0";
export var printerIcon = "_k6-8";
export var printerIconConfigured = "_k6-5";
export var printerIconContainer = "_k6-4";
export var printerIconError = "_k6-6";
export var printerIconUnconfigured = "_k6-7";
export var workstationsTableCard = "_k6-9";